module.exports = __webpack_public_path__ + "img/yakitori-bento.877bb83f.png";